import router from "@/router";
import axios, { getIsLogin } from "./axios";
import { Toast, Dialog } from "vant";

/*--------------- Title、 keyworlds、 descriptionText相关 start ↓ ---------------------*/

// 首页Title、 keyworlds、 descriptionText
const homeTitlt = "瑞杰创新科技致力于无人机、机器人、智能设备配件的引领者";
const homeKeywords =
  "GPS定位模组|TOF光流模组|BMS电池管理系统|激光模组|扫地机|电调|无刷电机驱动|360激光雷达|车调|无人机|无人清洁解决方案";
const homeDescription = "欢迎来到瑞杰创新官网";
// const baiduToken = {
//   "@context": "https://ziyuan.baidu.com/contexts/cambrian.jsonId",
//   "@Id": "https://www.yangziclean.com/",
//   "appid": "",
//   "title": homeTitlt,
//   "images": [
//     "https://www.yangziclean.com/public/upload/logo/2020/03-17/42138198d3bb61cba80ac3d0d5bcab24.png"
//   ],
//   "description": homeDescription,
//   "pubDate": "2020-08-24T11:48:01",
//   "upDate": "2020-08-24T11:48:01",
//   "lrDate": "2020-08-24T11:48:01"
// }

// 当前页面Title
let $titleText = homeTitlt;

// 当前页面keyWords
let $keywordsText = homeKeywords;

// 当前页面descriptionText
let $descriptionText = homeDescription;

// 初始化页面TDK
function initializationTDK() {
  setTitle(homeTitlt);
  setKeywords(homeKeywords);
  setDescription(homeDescription);
}

// 设置当前页面Titlt
export function setTitle(titleT) {
  $titleText = titleT;
  document.title = $titleText;
}

// 设置当前页面keywords
function setKeywords(keywordsT) {
  $keywordsText = keywordsT;
  let head = document.head;
  let keywordsEle = document.createElement("meta");
  keywordsEle.setAttribute("name", "keywords");
  keywordsEle.setAttribute("content", $keywordsText);
  head.appendChild(keywordsEle);
}

// 设置当前页面description
function setDescription(descriptionT) {
  $descriptionText = descriptionT;
  let head = document.head;
  let descriptionEle = document.createElement("meta");
  descriptionEle.setAttribute("name", "description");
  descriptionEle.setAttribute("content", $descriptionText);
  head.appendChild(descriptionEle);
}

// 获取当前页面TDK
function getTDK() {
  return {
    title: $titleText,
    keywords: $keywordsText,
    description: $descriptionText
  };
}

/*--------------- Title、 keyworlds、 descriptionText相关 end ↑ ---------------------*/

/*--------------- 时间戳操作相关 start ↓ ---------------------*/

//	依据时间戳获取 YYYY-mm-DD hh:MM:hh 格式时间
export function formate(timestamp) {
  // 调用的方法
  return formatTime(timestamp / 1000, "Y-M-D h:m:s");
}
function formatTime(number, format) {
  var formateArr = ["Y", "M", "D", "h", "m", "s"];
  var returnArr = [];

  var date = new Date(number * 1000);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));

  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}
function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : "0" + n;
}

// 依据type获取时间戳的年份或者月份
function getTimeByType(timeStamp, type) {
  let time = timeStamp / 1000;
  let minute = Math.floor(time / 60);
  let hour = Math.floor(minute / 60);
  let day = Math.floor(hour / 24);
  minute = minute - hour * 60;
  hour = hour - day * 24;
  let second = parseInt(
    time - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
  );
  hour = hour + day * 24;
  if (type == "day") {
    day = day > 9 ? day : "0" + day;
    return day;
  } else if (type == "hour") {
    hour = hour > 9 ? hour : "0" + hour;
    return hour;
  } else if (type == "minute") {
    minute = minute > 9 ? minute : "0" + minute;
    return minute;
  } else if (type == "second") {
    second = second > 9 ? second : "0" + second;
    return second;
  }
}

/*--------------- 时间戳操作相关 end ↑ ---------------------*/

// 清洁设计方案页面的推广文案
const schemeWriting =
  "我公司发展至今，拥有成熟稳定的管理体系及年轻的管理队伍，为我公司的稳定发展提供保障，专业高能的研发能力，生产制造能力和先进的机械设备以及凭借多年的研发生产和品质管理经验";

//  判断是否为IE浏览器
const isIE = !!window.ActiveXObject || "ActiveXObject" in window;

// 保留两位小数
function changeTwoDecimal_f(x) {
  var f_x = parseFloat(x);
  if (isNaN(f_x)) {
    return 0;
  }
  var f_x = Math.round(x * 100) / 100;
  var s_x = f_x.toString();
  var pos_decimal = s_x.indexOf(".");
  if (pos_decimal < 0) {
    pos_decimal = s_x.length;
    s_x += ".";
  }
  while (s_x.length <= pos_decimal + 2) {
    s_x += "0";
  }
  return s_x;
}

// 判断元素任何部分是否在窗口出现
function elementInViewport(el) {
  var top = el.offsetTop;
  var height = el.offsetHeight;
  let dom = document.getElementsByTagName("html")[0];
  return dom.scrollTop > top - height * 2.5 - 17;
}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === "string") {
      time = time.replace(new RegExp(/-/gm), "/");
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

// 限定字符长度，超出则在末尾加省略号
function subStr(str, length) {
  if (!str) {
    return "";
  }
  if (str.length > length) {
    return str.substring(0, length) + "…";
  }
  return str;
}

var astest = 50;
function setastest(num) {
  astest = num;
}
function getastest() {
  return astest;
}

// 如果用户是登录状态则前往toPageName页面, 否则前往unLogePageName页面
function linkToUserPerson(toPageName, unLogePageName) {
  if (getIsLogin()) {
    router.push({ name: toPageName });
  } else {
    router.push({ name: unLogePageName });
  }
}

// 在新标签页打开网页
function openNewWindow(pageName, data, type) {
  let urlInfo = {
    name: pageName
  };
  if (type == "params") {
    urlInfo.params = data;
  } else {
    urlInfo.query = data;
  }
  let routeData = router.resolve(urlInfo);
  window.open(routeData.href, "_blank");
}

// 做点什么
function doSoming() {
  Toast({
    duration: 3000,
    message: "该功能还未上线，敬请期待",
    position: "bottom"
  });
}

// 将会被重新加载的已缓存页面列表
let reloadPageList = ["distributionMap"];

// 插入被缓存的页面名称， 下次进入该缓存页面将重新请求获取页面数据
export function inseartReloadPage(pageName) {
  if (reloadPageList.indexOf(pageName) >= 0) {
    return;
  } else {
    reloadPageList.push(pageName);
  }
}

// 判断该页面是否需要重新获得数据
export function isReloadPage(pageName) {
  if (reloadPageList.indexOf(pageName) >= 0) {
    for (let i = 0; i < reloadPageList.length; i++) {
      if (reloadPageList[i] == pageName) {
        reloadPageList.splice(i, 1);
        break;
      }
    }
    return true;
  } else {
    return false;
  }
}

//将base64转换为文件
function dataURLtoFile(dataurl, filename) {
  // data:image/jpg;base64,
  let st = "data:image/jpg;base64,";
  let stPng = "data:image/png;base64,";
  if (dataurl.indexOf(st) < 0 && dataurl.indexOf(stPng) < 0) {
    dataurl = st + dataurl;
  }
  dataurl = dataurl.replaceAll(" ", "");
  var arr = dataurl.split(",");
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

// 深度拷贝
function deepCopy(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  let copy;
  if (Array.isArray(obj)) {
    copy = [];
    for (let i = 0; i < obj.length; i++) {
      copy[i] = deepCopy(obj[i]);
    }
  } else {
    copy = {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        copy[key] = deepCopy(obj[key]);
      }
    }
  }
  return copy;
}

// 将TDK相关函数注册到Vue中， 可以在任何页面使用 this.$ + 函数名 调用
export default {
  install: function(Vue) {
    // 注册TDK相关组件
    Vue.prototype.$initializationTDK = () => initializationTDK();
    Vue.prototype.$setTitle = titleT => setTitle(titleT);
    Vue.prototype.$setKeywords = keywordsT => setKeywords(keywordsT);
    Vue.prototype.$setDescription = descriptionTextT =>
      setDescription(descriptionTextT);
    Vue.prototype.$getTDK = () => getTDK();
    // 时间戳操作相关
    Vue.prototype.$formate = timestamp => formate(timestamp);
    Vue.prototype.$formatTime = (timestamp, formate) =>
      formatTime(timestamp, formate);
    Vue.prototype.$getTimeByType = (timeStamp, type) =>
      getTimeByType(timeStamp, type);

    Vue.prototype.$schemeWriting = schemeWriting;
    Vue.prototype.$isIE = isIE;
    Vue.prototype.$changeTwoDecimal_f = num => changeTwoDecimal_f(num);

    Vue.prototype.$elementInViewport = el => elementInViewport(el);
    Vue.prototype.$subStr = (str, length) => subStr(str, length);
    Vue.prototype.$setastest = num => setastest(num);
    Vue.prototype.$parseTime = (time, pattern) => parseTime(time, pattern);
    Vue.prototype.$getastest = () => getastest();

    // 判断用户是否登录
    Vue.prototype.$linkToUserPerson = (toPageName, unLogePageName) =>
      linkToUserPerson(toPageName, unLogePageName);

    // 新窗口打开页面
    Vue.prototype.$openNewWindow = (pageName, data, type) =>
      openNewWindow(pageName, data, type);

    // 缓存相关
    Vue.prototype.$inseartReloadPage = pageName => inseartReloadPage(pageName);
    Vue.prototype.$isReloadPage = pageName => isReloadPage(pageName);

    Vue.prototype.$doSoming = () => doSoming();

    // base64操作
    Vue.prototype.$dataURLtoFile = (dataurl, filename) =>
      dataURLtoFile(dataurl, filename);
    Vue.prototype.$deepCopy = (obj) => deepCopy(obj);
      
  }
};



// WEBPACK FOOTER //
// ./src/util/publicFun.js